/// <reference path="../../../../typings/index.d.ts" />
///<reference path="../../components/baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../components/common/common.interface.ts"/>

module Meevo.Plugins.AlertsLog {

    import SecurityKeys = Meevo.Components.Common.SecurityKeys;
    import SecurityParts = Meevo.Components.Common.SecurityParts;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    export interface IAlertsLogService {
        readonly alertsCount: number;

        updateAlertsCount(): void;
        markAsRead(): void;
    }

    class AlertsLogService implements IAlertsLogService {

        static factory(): Function {
            const alertsLogService = (
                dataService: Meevo.Components.BaseClasses.IDataService,
                identityService: Meevo.Components.Common.IIdentityService,
                securityService: Meevo.Components.Common.ISecurityService,
                appSettings: Meevo.Components.Common.IAppSettings
            ) => new AlertsLogService(dataService, identityService, securityService, appSettings);

            alertsLogService.$inject = [
                'meevo.components.common.DataService',
                'meevo.components.common.IdentityService',
                'meevo.components.common.SecurityService',
                'meevo.AppSettings'
            ];
            return alertsLogService;
        }

        private _alertsCount: number;

        get alertsCount() {
            return this._alertsCount;
        }

        constructor(private dataService: Meevo.Components.BaseClasses.IDataService,
                    private identityService: Meevo.Components.Common.IIdentityService,
                    private securityService: Meevo.Components.Common.ISecurityService,
                    private appSettings: Meevo.Components.Common.IAppSettings) {
            this._alertsCount = 0;

            this.updateAlertsCount();
        }

        /**
         * Method updates the alerts count
         */
        updateAlertsCount() {
            this.securityService
                .checkSecurityItem(SecurityKeys.MANAGEMENT_ALERTSLOG + SecurityParts.KEY_PART_READ)
                .then((securityItem) => {
                    if (securityItem && securityItem.securityAccess === SecurityAccessEnum.Grant) {
                        this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.alertLogDetail}/Count`, 'POST', {
                            criteria: {
                                triggeredToUserId: this.identityService.current().userId
                            }
                        }).then(response => {
                            this._alertsCount = response.data;
                        });
                    }
                });
        }

        markAsRead() {
            this.securityService
                .checkSecurityItem(SecurityKeys.MANAGEMENT_ALERTSLOG + SecurityParts.KEY_PART_WRITE)
                .then((securityItem) => {
                    if (securityItem && securityItem.securityAccess === SecurityAccessEnum.Grant) {
                        this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.alertsLog}/markAsRead`, 'PUT', {
                            triggeredToUserId: this.identityService.current().userId
                        });
                    }
                });
        }
    }

    angular.module('meevo.plugins.alertsLog')
        .service('meevo.plugins.alertsLog.AlertsLogService', AlertsLogService.factory());
}
